import { Container, Grid, useMediaQuery } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import React from "react";
import img from "../../../../assets/images/home_content_4.png";
import IconHeader from "../../components/iconHeader";
import TextList from "../../components/TextList";

const useStyles = makeStyles((theme) => ({
  img: {
    width: "100%",
  },
}));

export default function TopupHeader() {
  const classes = useStyles();
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.up("sm"));
  const xs = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <Container>
      <Grid container direction="row" justifyContent="center" alignItems="center">
        {xs && (
          <Grid item xs={6}>
            <IconHeader
              title="Get Paid"
              iconColor="#cb010d"
              titleColor="#F7517B"
              titleLg="h2"
              titleXs="h4"
            />
          </Grid>
        )}
        {xs && (
          <Grid item xs={6}>
            <img src={img} alt="partners" className={classes.img}/>
          </Grid>
        )}
        <Grid item container xs={12} sm={7}>
          {sm && (
            <Grid item>
              <IconHeader
                title="Get Paid"
                iconColor="#cb010d"
                titleColor="#F7517B"
                titleLg="h2"
              />
            </Grid>
          )}

          <Grid item container>
            <TextList
              items={[
                <span>
                Looking for safe, convenient, affordable ways for your customers and clients to pay? If the answer is YES, the answer is &nbsp;
                <b>YOOZ</b>
              </span>,
              <span>
                Through our multiple payment channels, we can help you improve your payment collection by 
                connecting with your customers and partners wherever they are. As an added bonus, you will have access to over 250,000 
                <b>YOOZ</b> customers.
                
              </span>,
            
              <span>
                Cash or card, debit or credit, our extensive payment channel offering caters to the needs and means of your cusotmers.
              </span>,
              ]}
            />
          </Grid>
        </Grid>
        {sm && (
          <Grid item xs={6} sm={5}>
            <img src={img} alt="partners" className={classes.img} />
          </Grid>
        )}
      </Grid>
    </Container>
  );
}
